import {
  SET_WATCH_FEATURED,
  SET_NOW_SHOWING,
  SET_COMING_SOON,
  SET_MOVIE_MODAL_DATA,
  SET_MOVIE_MODAL_STATUS,
  SET_TICKET_COUNT,
  // TODO: import action types added later
} from './actions/types'

const INITIAL_STATE = {
  watchFeatured: [],
  nowShowing: [],
  comingSoon: [],
  showMovieModal: false,
  movieModalData: {},
  movieModalStatus: null,
  ticketCount: 0,
}

function setWatchFeatured(state, action) {
  return {
    ...state,
    watchFeatured: action.payload.watchFeatured,
  }
}
function setNowShowing(state, action) {
  return {
    ...state,
    nowShowing: action.payload.nowShowing,
  }
}
function setComingSoon(state, action) {
  return {
    ...state,
    comingSoon: action.payload.comingSoon,
  }
}
function setPromoModalStatus(state, action) {
  const { movieModalStatus } = action.payload

  return {
    ...state,
    showMovieModal: movieModalStatus !== null,
    movieModalStatus,
  }
}
function setMovieModalData(state, action) {
  return {
    ...state,
    movieModalData: action.payload.movieModalData,
  }
}
function setTicketCount(state, action) {
  return {
    ...state,
    ticketCount: action.payload.ticketCount,
  }
}
// TODO: reflect state mutator functions for action types added later

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_WATCH_FEATURED:
      return setWatchFeatured(state, action)
    case SET_NOW_SHOWING:
      return setNowShowing(state, action)
    case SET_COMING_SOON:
      return setComingSoon(state, action)
    case SET_MOVIE_MODAL_DATA:
      return setMovieModalData(state, action)
    case SET_MOVIE_MODAL_STATUS:
      return setPromoModalStatus(state, action)
    case SET_TICKET_COUNT:
      return setTicketCount(state, action)
    default:
      break
  }

  return state
}

export default reducer
